/**
 * Created by DejanK on 10/8/2016.
 */
import './rb-select.scss';

const template =`<a href="#" ng-click="$ctrl.onClick($event)" ng-transclude></a>`;

export default {
  template: template,
  transclude: true,
  require: {
    rbSelect: '?^rbSelect'
  },
  bindings: {
    value: '<',
    index: '<'
  },
  controller: Ctrl
};

Ctrl.$inject = ['$scope', '$element'];
function Ctrl($scope, $element){
  const vm = this;
  let registered;

  vm.$onInit = onInit;
  vm.$onDestroy = onDestroy;
  vm.onClick = onClick;

  vm.select = select;
  vm.deselect = deselect;

  vm.scrollIntoView = ()=>{
    $element[0].scrollIntoView();
  };

  vm.setFocus = ()=>{
    vm.scrollIntoView();
    $element.addClass('focused');
  };

  vm.removeFocus = ()=>{
    $element.removeClass('focused');
  };

  vm.getText = () => {
    return $element.text().trim();
  };

  function onInit(){
    if(vm.rbSelect){
      vm.rbSelect.registerOption(vm);
      registered = 1;
    }

  }

  function onDestroy(){
    if (registered) vm.rbSelect.deregisterOption(vm);
  }

  function onClick($event){
    $event.stopPropagation();
    $event.preventDefault();
    vm.rbSelect.onSelect(vm.value);
  }

  function select(){
    $element.addClass('selected');
    return $element.find('a').html();
  }

  function deselect(){
    $element.removeClass('selected');
  }
}
